import { render, staticRenderFns } from "./HomePageTemplate.vue?vue&type=template&id=6d20086a&scoped=true"
import script from "./HomePageTemplate.vue?vue&type=script&lang=js"
export * from "./HomePageTemplate.vue?vue&type=script&lang=js"
import style0 from "./HomePageTemplate.vue?vue&type=style&index=0&id=6d20086a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d20086a",
  null
  
)

export default component.exports